var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"block max-w-full text-center truncate",class:['status', `status--${_vm.value}`, _vm.className],attrs:{"title":_vm.value}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }